export default {"src":"/_next/static/media/ci.1758efc8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};